// src/components/features/Navigacia/tour/sections/homeMenu.js
import { i18n } from "@/i18n";
import { steps as zapisySteps, branch as zapisyBranch } from "./ciselneZapisy";
import { steps as videoSteps, branch as videoBranch } from "./naucneVidea";
import { isMobileMenuLayout } from "../utils/mobileMenu";

const translate = (...args) => i18n.global.t(...args);

export function steps() {
  const pad = 18;
  const mobile = isMobileMenuLayout();
  const t = translate;

  const commonSteps = [
    // 1) Zistiť viac
    {
      goto: "/",
      selector: [
        "a[href*='zistit-viac' i]",
        "a[href*='zisti' i]",
        "[data-qa*='zistit-viac' i]",
      ].join(","),
      bind: { text: t("menu.zistitViac"), hrefLike: "zisti" },
      title: t("tour.sections.homeMenu.common.discover.title"),
      text: t("tour.sections.homeMenu.common.discover.text"),
      side: "bottom",
      pad,
    },
    // 2) Vyskúšať zadarmo
    {
      goto: "/",
      selector: [
        "a[href*='zadarmo' i]",
        "a[href*='vyskusat' i]",
        "a[href*='trial' i]",
        "button[href*='zadarmo' i]",
        "[data-gtm*='zadarmo' i]",
        "[data-qa*='zadarmo' i]",
        "[data-qa*='trial' i]",
      ].join(","),
      bind: { text: t("home.hero.ctaTry"), hrefLike: "zadarmo" },
      title: t("tour.sections.homeMenu.common.trial.title"),
      text: t("tour.sections.homeMenu.common.trial.text"),
      side: "bottom",
      pad,
    },
  ];

  const desktopTiles = [
    {
      bind: { text: t("menu.naucneVidea") },
      closest: ".box-main",
      title: t("tour.sections.homeMenu.desktopTiles.videos.title"),
      text: t("tour.sections.homeMenu.desktopTiles.videos.text"),
      side: "top",
      pad: { top: 30, right: 26, bottom: 26, left: 26 },
      radius: 34,
    },
    {
      bind: { text: t("menu.ciselneZapisy"), hrefLike: "cisel" },
      closest: ".box-main",
      title: t("tour.sections.homeMenu.desktopTiles.scores.title"),
      text: t("tour.sections.homeMenu.desktopTiles.scores.text"),
      side: "top",
      pad: [26, 24],
      radius: 34,
    },
    {
      bind: { text: t("menu.helishop"), hrefLike: "helishop" },
      closest: ".box-main",
      title: t("tour.sections.homeMenu.desktopTiles.shop.title"),
      text: t("tour.sections.homeMenu.desktopTiles.shop.text"),
      side: "top",
      pad: 26,
      radius: 34,
    },
    {
      bind: { text: t("menu.helifest"), hrefLike: "helifest" },
      closest: ".box-main",
      title: t("tour.sections.homeMenu.desktopTiles.festival.title"),
      text: t("tour.sections.homeMenu.desktopTiles.festival.text"),
      side: "top",
      pad: 26,
      radius: 34,
    },
  ];

  const mobileTiles = [
    {
      selector: ".mobile .second.mobile .box-main:nth-of-type(1)",
      title: t("tour.sections.homeMenu.mobileTiles.videos.title"),
      text: t("tour.sections.homeMenu.mobileTiles.videos.text"),
      side: "top",
      pad: { x: 24, y: 20 },
      radius: 34,
    },
    {
      selector: ".mobile .second.mobile .box-main:nth-of-type(2)",
      title: t("tour.sections.homeMenu.mobileTiles.scores.title"),
      text: t("tour.sections.homeMenu.mobileTiles.scores.text"),
      side: "top",
      pad: { x: 24, y: 20 },
      radius: 34,
    },
    {
      selector: ".mobile .second.mobile .box-main:nth-of-type(3)",
      title: t("tour.sections.homeMenu.mobileTiles.shop.title"),
      text: t("tour.sections.homeMenu.mobileTiles.shop.text"),
      side: "top",
      pad: { x: 24, y: 20 },
      radius: 34,
    },
    {
      selectors: [
        ".mobile .mobile-newslist .news",
        ".mobile .mobile-newslist .news-list",
      ],
      title: t("tour.sections.homeMenu.mobileTiles.news.title"),
      text: t("tour.sections.homeMenu.mobileTiles.news.text"),
      side: "top",
      pad: { x: 24, y: 20 },
      radius: 24,
    },
    {
      selector: ".mobile .mobile-frstbook .book-card",
      title: t("tour.sections.homeMenu.mobileTiles.book.title"),
      text: t("tour.sections.homeMenu.mobileTiles.book.text"),
      side: "top",
      pad: { x: 26, y: 24 },
      radius: 26,
    },
  ];

  const desktopMenuSteps = [
    {
      bind: {
        where: "menu",
        text: t("menu.textyPiesni"),
        hrefLike: "spevnik",
      },
      title: t("tour.sections.homeMenu.desktopMenu.lyrics.title"),
      text: t("tour.sections.homeMenu.desktopMenu.lyrics.text"),
      side: "left",
      pad: 10,
    },
    {
      bind: { where: "menu", text: t("menu.oNas"), hrefLike: "o-nas" },
      title: t("tour.sections.homeMenu.desktopMenu.about.title"),
      text: t("tour.sections.homeMenu.desktopMenu.about.text"),
      side: "left",
      pad: 10,
    },
    {
      bind: { where: "menu", text: t("menu.kosik"), hrefLike: "kosik" },
      title: t("tour.sections.homeMenu.desktopMenu.cart.title"),
      text: t("tour.sections.homeMenu.desktopMenu.cart.text"),
      side: "left",
      pad: 10,
    },
    {
      bind: { where: "menu", text: t("menu.pomoc"), hrefLike: "pomoc" },
      title: t("tour.sections.homeMenu.desktopMenu.help.title"),
      text: t("tour.sections.homeMenu.desktopMenu.help.text"),
      side: "left",
      pad: 10,
    },
  ];

  const mobileMenuSteps = [
    {
      selector: "[data-tour-id='home-menu-mobile-cart']",
      title: t("tour.sections.homeMenu.mobileMenu.cart.title"),
      text: t("tour.sections.homeMenu.mobileMenu.cart.text"),
      side: "top",
      pad: { x: 18, y: 14 },
      radius: 32,
      mobileMenu: "close",
      mobileMenuDelay: 200,
    },
    {
      selector: "[data-tour-id='home-menu-mobile-toggle']",
      title: t("tour.sections.homeMenu.mobileMenu.open.title"),
      text: t("tour.sections.homeMenu.mobileMenu.open.text"),
      side: "top",
      pad: { x: 20, y: 14 },
      radius: 36,
      mobileMenu: "open",
      mobileMenuDelay: 260,
      waitFor: 200,
    },
    {
      selector: "[data-tour-id='home-menu-mobile-texty']",
      title: t("tour.sections.homeMenu.mobileMenu.lyrics.title"),
      text: t("tour.sections.homeMenu.mobileMenu.lyrics.text"),
      side: "right",
      pad: { x: 18, y: 14 },
      radius: 30,
      mobileMenu: "open",
      mobileMenuDelay: 220,
      waitFor: 220,
    },
    {
      selector: "[data-tour-id='home-menu-mobile-about']",
      title: t("tour.sections.homeMenu.mobileMenu.about.title"),
      text: t("tour.sections.homeMenu.mobileMenu.about.text"),
      side: "right",
      pad: { x: 18, y: 14 },
      radius: 30,
      mobileMenu: "open",
      mobileMenuDelay: 220,
      waitFor: 220,
    },
    {
      selector: "[data-tour-id='home-menu-mobile-help']",
      title: t("tour.sections.homeMenu.mobileMenu.help.title"),
      text: t("tour.sections.homeMenu.mobileMenu.help.text"),
      side: "right",
      pad: { x: 18, y: 14 },
      radius: 30,
      mobileMenu: "open",
      mobileMenuDelay: 220,
      waitFor: 220,
    },
    {
      selector: "[data-tour-id='home-menu-mobile-toggle']",
      title: t("tour.sections.homeMenu.mobileMenu.close.title"),
      text: t("tour.sections.homeMenu.mobileMenu.close.text"),
      side: "top",
      pad: { x: 20, y: 14 },
      radius: 36,
      mobileMenu: "close",
      mobileMenuDelay: 240,
      waitFor: 200,
    },
    {
      selector: "[data-tour-id='home-menu-mobile-songs']",
      title: t("tour.sections.homeMenu.mobileMenu.songs.title"),
      text: t("tour.sections.homeMenu.mobileMenu.songs.text"),
      side: "top",
      pad: { x: 20, y: 16 },
      radius: 26,
      mobileMenu: "close",
      mobileMenuDelay: 200,
      waitFor: 180,
    },
    {
      selector: "[data-tour-id='home-menu-mobile-home']",
      title: t("tour.sections.homeMenu.mobileMenu.home.title"),
      text: t("tour.sections.homeMenu.mobileMenu.home.text"),
      side: "top",
      pad: { x: 20, y: 16 },
      radius: 26,
      mobileMenu: "close",
      mobileMenuDelay: 200,
      waitFor: 180,
    },
    {
      selector:
        "[data-tour-id='home-menu-mobile-login'], [data-tour-id='home-menu-mobile-account']",
      title: t("tour.sections.homeMenu.mobileMenu.account.title"),
      text: t("tour.sections.homeMenu.mobileMenu.account.text"),
      side: "top",
      pad: { x: 20, y: 16 },
      radius: 26,
      mobileMenu: "close",
      mobileMenuDelay: 200,
      waitFor: 180,
    },
  ];

  return [
    ...commonSteps,
    ...(mobile ? mobileTiles : desktopTiles),
    ...(mobile ? mobileMenuSteps : desktopMenuSteps),
  ];
}

export function branch() {
  const t = translate;

  return {
    title: t("tour.branches.homeMenu.title"),
    text: t("tour.branches.homeMenu.text"),
    planBridgeLabel: t("tour.branches.homeMenu.planBridgeLabel"),
    options: [
      {
        label: t("tour.branches.homeMenu.options.scores.label"),
        goto: "/ciselne-zapisy",
        key: "zapisy",
        name: "zapisy",
        planLabel: t("tour.branches.homeMenu.options.scores.planLabel"),
        steps: zapisySteps,
        branch: zapisyBranch,
        planBridgeLabel: t(
          "tour.branches.homeMenu.options.scores.planBridgeLabel"
        ),
      },
      {
        label: t("tour.branches.homeMenu.options.videos.label"),
        goto: "/naucne-videa",
        key: "video",
        name: "video",
        planLabel: t("tour.branches.homeMenu.options.videos.planLabel"),
        steps: videoSteps,
        branch: videoBranch,
        planBridgeLabel: t(
          "tour.branches.homeMenu.options.videos.planBridgeLabel"
        ),
      },
    ],
  };
}
